// extracted by mini-css-extract-plugin
export var darkMode = "_s-0";